import React, { Component } from 'react';
import './footer.css';

export default class Footer extends Component {
  onMenuClick = (option) => {
    switch (option) {
      case 'Sobre':
        window.location.hash = '#/about';
        break;
      case 'Termos de uso':
        window.location.hash = '#/terms';
        break;
      case 'Política de privacidade':
        window.open('https://www.sp.senac.br/politica-de-privacidade', '_blank');
        break;
      case 'Fale conosco':
        window.location.hash = '#/contact';
        break;
      case 'Dúvidas frequentes':
        window.location.hash = '#/faq';
        break;
      default:
        break;
    }
  }

  render() {
    const menuOptions = [
      'Sobre',
      'Termos de uso',
      'Política de privacidade',
      'Fale conosco',
      'Dúvidas frequentes'
    ];

    const currentYear = new Date().getFullYear();

    return (
      <div className="rdp-react-template-footer">
        <div className="rdp-react-template-footer-container">
          <div className="rdp-react-template-footer-options">
            {menuOptions.map((option) => (
              <span 
                key={option} 
                onClick={() => this.onMenuClick(option)}
                className="rdp-react-template-footer-option"
              >
                {option}
              </span>
            ))}
          </div>

          <div className="rdp-react-template-footer-info">
            <div className="rdp-react-template-footer-copyright">
              Copyright © {currentYear}. Todos os direitos reservados.
            </div>

            <div className="rdp-react-template-footer-company">
              <div>Serviço Nacional de Aprendizagem Comercial – SP</div>
              <div>CNPJ: 03.709.814/0001-98</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}